export class JetLiftMainReport {
    // Report header (same as MainReport)
    Case_ModifiedDate?: string;
    CustomerName?: string;

    // Basic project info
    projectId?: string;
    ProjectName?: string;
    projectName?: string;
    documentName?: string;
    CaseName?: string;
    CompanyName?: string;
    customerName?: string;
    WellName?: string;
    wellName?: string;
    DALRep?: string;
    
    // Casing and tubing properties
    CasingOD?: string;
    CasingOD_Unit?: string;
    CasingWeight?: string;
    CasingWeight_Unit?: string;
    Casing?: string;
    Tubing1?: string;
    Tubing2?: string;
    CasingID?: string;
    CasingID_Unit?: string;
    tubing1_TubingOD?: string;
    tubing1_TubingOD_Unit?: string;
    tubing1_TubingWeight?: string;
    tubing1_TubingWeight_Unit?: string;
    tubing1_Tubing?: string;
    tubing1_TubingID?: string;
    tubing1_TubingID_Unit?: string;
    tubing1_TubingType?: string;
    tubing2_TubingOD?: string;
    tubing2_TubingOD_Unit?: string;
    tubing2_TubingWeight?: string;
    tubing2_TubingWeight_Unit?: string;
    tubing2_Tubing?: string;
    tubing2_TubingID?: string;
    tubing2_TubingID_Unit?: string;
    tubing2_TubingType?: string;
    LinerOD?: string;
    LinerOD_Unit?: string;
    LinerWeight?: string;
    LinerWeight_Unit?: string;
    Liner?: string;
    LinerID?: string;
    LinerID_Unit?: string;
    pipeRoughness?: string;
    pipeRoughness_ed_Ld?: string;
    
    // Well properties
    perforationDepth?: string;
    pumpVerticalDepth?: string;
    pumpInstallation?: string;
    casingProductionID?: string;
    powerTubingID?: string;
    powerTubingOD?: string;
    tubingLength?: string;
    flowLinePressure?: string;
    flowLinePressure_unit?: string;
    desiredProductionRate?: string;
    bpd_unit?: string;
    pumpSuctionPressure?: string;
    pressure_unit?: string;
    settingDepth?: string;
    pumpSettingVerticalDepth?: string;
    reservoirDatum?: string;
    flop?: string;
    ft_unit?: string;
    productivityIndex?: string | number;
    staticBottomHolePressurePI?: string;
    staticFluidLevelfromSurfacePI?: string;
    staticBottomHolePressureP?: string;
    flowingBottomHolePressureP?: string;
    testFlowRateP?: string;
    staticFuidLevelfromSurfaceHead?: string;
    producingFluidLevelfromSurfaceHead?: string;
    testFlowRateHead?: string;
    pumpSetting?: string;
    perforation?: string;
    tvd?: string;
    staticBHP?: string | number;
    flowingBHP?: string | number;
    testFlowRate?: string;
    staticFL?: string | number;
    producingFL?: string | number;
    
    // Well data properties
    wellStaticBHP?: string;
    pumpIntakePress?: string;
    wellTestFlowRate?: string;
    targetProductionRate_blpd?: string;
    
    // Fluid properties
    oilGravity?: string;
    producedVolWaterCut?: string;
    waterSpecificGravity?: string;
    producingGOR_scfstb?: string;
    gasSpecificGravity?: string;
    wellHeadTemp?: string;
    bottomHoleTemp?: string;
    bubblePointPress?: string;
    wellHeadPress?: string;
    reservoirPressure?: string;
    waterCut_fraction?: string;
    flowRate?: string;
    flowingBottomHolePressure?: string;
    overriddenBubblePointPressure?: string;
    targetPumpIntakePressure?: string;
    spGrWater?: string;
    waterCut?: string;
    bwpd?: string;
    oilAPI?: string;
    spGrOil?: string;
    oilCut?: string;
    bopd?: string;
    averageCombinedSpGr?: string;
    liquidPhaseCombinedSpGr?: string;
    compositeSpGr?: string;
    fluidViscosity?: string;
    gasAvailblty?: string;
    viscosity_unit?: string;
    gasProduction?: string;
    gasProduction_unit?: string;
    gor?: string;
    gor_unit?: string;
    glr?: string;
    glr_unit?: string;
    specificGravityGas?: string;
    gasCompressibility?: string;
    bubblePointPressure?: string;
    bottomHoleTemperature?: string;
    surfaceTemperature?: string;
    temperature_unit?: string;
    region?: string;
    percentage_unit?: string;
    
    // Jet pump properties
    gasVented?: string;
    powerFluidOilWater?: string;
    powerFluidAPI?: string;
    manufacturer?: string;
    nozzleDiameterSize?: string;
    nozzleAreaSize?: string;
    nozzleValue?: string;
    nozzleDiameter?: string;
    in_unit?: string;
    throatDiameterSize?: string;
    throatAreaSize?: string;
    throatValue?: string;
    throatDiameter?: string;
    minFluidRange?: string;
    stepFluidRange?: string;
    maxFluidRange?: string;
    gasVent?: string;
    powerFluidType?: string;
    powerFluidDensity?: string;
    outputPressures?: string;
    recommended_vessel_size?: string | null;
    recommended_charge_pump_size?: string | null;
    recommended_surface_pump_size?: string | null;
    recommended_plunget_size?: string | null;
    selected_vessel_size?: string | null;
    selected_charge_pump_size?: string | null;
    selected_surface_pump_size?: string | null;
    selected_plunget_size?: string | null;
    schematics_jet_pump_size?: string | null;
    
    // Performance results
    predSurfacePowerFluidInjectionPressure?: string;
    predSurfacePowerFluidInjectionRate?: string;
    predPumpIntakePressure?: string;
    predPumpDischargePressure?: string;
    predPowerFluidPressureAtPumpDepth?: string;
    predHorsepowerRequirement?: string;
    
    // Match production rates (aligned with JLMainReportModel)
    matchProdRate1_Blpd?: string;
    matchPowerFluidRate1_QN?: string;
    matchPowerFluidPress1_PFP?: string;
    matchPumpIntakePress1_PIP?: string;
    matchPumpDischargePress1_PD?: string;
    matchPowerFluidPress1_PN?: string;
    matchProdRate2_Blpd?: string;
    matchPowerFluidRate2_QN?: string;
    matchPowerFluidPress2_PFP?: string;
    matchPumpIntakePress2_PIP?: string;
    matchPumpDischargePress2_PD?: string;
    matchPowerFluidPress2_PN?: string;
    matchProdRate3_Blpd?: string;
    matchPowerFluidRate3_QN?: string;
    matchPowerFluidPress3_PFP?: string;
    matchPumpIntakePress3_PIP?: string;
    matchPumpDischargePress3_PD?: string;
    matchPowerFluidPress3_PN?: string;
    matchProdRate4_Blpd?: string;
    matchPowerFluidRate4_QN?: string;
    matchPowerFluidPress4_PFP?: string;
    matchPumpIntakePress4_PIP?: string;
    matchPumpDischargePress4_PD?: string;
    matchPowerFluidPress4_PN?: string;
    
    // Performance curve and metadata
    performanceCurveData?: string;
    createdBy?: string;
    createdOn?: string;
    updatedBy?: string;
    updatedOn?: string;
    customerEmail?: string;
    customerRole?: string;
    reportFormat?: number;
    injectionPressureMinRange?: string;
    injectionPressureMaxRange?: string;
    pI_Tangent?: string;
    pI_Darcey?: string;
    downloadedBy?: string;
    downloadedDate?: string;
    casingOD?: string;
    productivityIndexPI?: string;
    oilRate?: string;
    gasRate?: string;
    waterRate?: string;

    // Gas intake data
    Gas_Intake_bg?: string;
    Gas_Intake_bo?: string;
    Gas_Intake_compositeSpGr?: string;
    Gas_Intake_flop?: string;
    Gas_Intake_freeGas?: string;
    Gas_Intake_gasCompressibility?: string;
    Gas_Intake_gasVolume?: string;
    Gas_Intake_glr?: string;
    Gas_Intake_gor?: string;
    Gas_Intake_liquidPhaseDensity?: string;
    Gas_Intake_naturalSepEff?: string;
    Gas_Intake_oilVolume?: string;
    Gas_Intake_pip?: string;
    psi_unit?: string;
    temp_unit?: string;
    Gas_Intake_rs?: string;
    Gas_Intake_temperatureOut?: string;
    Gas_Intake_tfv?: string;
    Gas_Intake_waterVolume?: string;
    Gas_Intake_liquidPhaseSpGr?: string;
    Gas_Intake_gvf?: string;
    
    // Chart and graph data
    IPRGraphData?: string;
    DepletionGraphData?: string;
    ShowIPRPlotOnMainReport?: boolean;
    ShowDepletionPlotOnMainReport?: boolean;
    
    // Chart axis properties
    iprGraphDataMaxXAxis?: string;
    iprGraphDataMaxYAxis?: string;
    iprGraphDataXAxisInterval?: string;
    iprGraphDataYAxisInterval?: string;
    depletionGraphDataXMax?: string;
    depletionGraphDataYMax?: string;
    depletionGraphDataXAxisInterval?: string;
    depletionGraphDataYAxisInterval?: string;
    
    // Performance data
    surfacePowerFluidInjectionPressure?: string;
    surfacePowerFluidInjectionRate?: string;
    pumpIntakePressure?: string;
    pumpDischargePressure?: string;
    powerFluidPressureAtPump?: string;
    horsePowerRequirement?: string;
    formattedBasicSummaryScenarios?: any;
    
    // System properties
    unitSystem?: number;
};